
import apiRequest from './apiRequest';

const leadApi = {
    createLead(leadData, token) {
        return apiRequest('/api/leads', 'POST', token, leadData);
    },

    getLead(id, token) {
        return apiRequest(`/api/leads/${id}`, 'GET', token);
    },

    updateLead(id, leadData, token) {
        return apiRequest(`/api/leads/${id}`, 'PUT', token, leadData);
    },

    deleteLead(id, token) {
        return apiRequest(`/api/leads/${id}`, 'DELETE', token);
    },

    getAllLeads(token, params = {}) {
        const queryString = new URLSearchParams(params).toString();
        const url = queryString ? `/api/leads/all?${queryString}` : '/api/leads/all';
        return apiRequest(url, 'GET', token);
    },

    convertLead(id, token) {
        return apiRequest(`/api/leads/${id}/convert`, 'POST', token);
    },

    getLeadsCreatedBy(token) {
        return apiRequest('/api/leads/report/created-by', 'GET', token);
    },

    getLeadsCreatedByRange(token, start, end) {
        const url = `/api/leads/report/created-by-range?start=${start}&end=${end}`;
        return apiRequest(url, 'GET', token);
    },

    getStatusSummary(token) {
        return apiRequest('/api/leads/report/status-summary', 'GET', token);
    },

    getLeadsCreatedBetween(token, start, end) {
        const url = `/api/leads/report/created-between?start=${start}&end=${end}`;
        return apiRequest(url, 'GET', token);
    },

    getStatusChangedToContacted(token, start, end) {
        const url = `/api/leads/report/status-changed-to-contacted?start=${start}&end=${end}`;
        return apiRequest(url, 'GET', token);
    },

    getStatusChangedTo(token, status, start, end) {
        const url = `/api/leads/report/status-changed-to?status=${encodeURIComponent(status)}&start=${start}&end=${end}`;
        return apiRequest(url, 'GET', token);
    },

    getLeadsByUser(token, userId, start, end) {
        const url = `/api/leads/report/leads-by-user?userId=${userId}&start=${start}&end=${end}`;
        return apiRequest(url, 'GET', token);
    },
     searchLead(searchTerm, token) {
        return apiRequest(`/api/leads/search/${searchTerm}`, 'GET', token);
    }
};

export default leadApi;
